<template>
    <div>
        <v-flex xs12 sm12 d-block class="card-dados card-dados__mobile">

            <div class="d-flex card-dados__titulo" >
                <h3 slot="activator" class="d-flex justify-space-between align-center">Proposta</h3>
                <v-flex v-if="ehReajusteFinalizado" class="d-inline-flex align-center justify-end">

                    <span style="max-width: 110px;">
                        <botao-assinar-com-borda v-if="deveMostrarBotaoAssinarRelatorioReajuste"
                                                 :assinado="reajusteAssinado"
                                                 :documentoVirtualizadoUrl="relatorioReajuste.urlAssinatura"/>
                    </span>

                    <span style="max-width: 100px;">
                        <botao-download-com-label @baixarDocumento="downloadReajuste"
                                                  :documentoVirtualizadoId="idVirtualizado"
                                                  v-if="idVirtualizado && ehCompraVirtualizada"
                                                  :ocultarOpcaoAssinado="!reajusteAssinado"/>
                    </span>
                </v-flex>
            </div>

            <div id="area-reajuste">
            <div v-show="ehVencedorDeUmOuMaisLotes()" class="legenda-destacada mb-2">

                <v-icon size="20px"
                        class="mr-3">
                    fas fa-exclamation-circle
                </v-icon>

                <p class="mensagem-aviso-reajuste">
                    Sr. Fornecedor, atualize os valores do grupo de itens para se adequar ao valor arrematado
                    e clique em <strong>"CONFIRMAR VALORES"</strong> no final da página.<br>
                </p>
            </div>

            <painel-lote v-if="reajusteLotes.length"
                         :reajusteLotes.sync="reajusteLotes"
                         :tipoCompraDireta="tipoCompraDireta"
                         :disputaCompraDireta="disputaCompraDireta"
                         :casasDecimais="casasDecimais"
                         :casasDecimaisQuantidade="casasDecimaisQuantidade"
                         :aceita-valor-zero="aceitaValorZero"
                         :criterioJulgamento="criterioJulgamentoDaCompra"
                         :simboloCriterioJulgamento="simboloCriterioJulgamentoDaCompra"
                         :validarLancesPor="validarIntervaloLancesPor"
                         :prefixSuffixValor="prefixOuSuffixValor"
                         :isCriterioJulgamentoMaiorDesconto="isCriterioJulgamentoMaiorDesconto"
                         @eventoAbrirModalReadequacao="eventoAbrirModalReadequacao"
                         @salvarItemReajuste="salvarItemLote"
                         @aceitarNegociacaoLote="enviarNegociacao"
                         @recusarNegociacaoLote="enviarNegociacao"
                         @exibirDialogoConfirmacao="exibirDialogoConfirmacao"/>

            <painel-item v-if="reajusteItens.length"
                         :reajusteItens.sync="reajusteItens"
                         :tipoCompraDireta="tipoCompraDireta"
                         :disputaCompraDireta="disputaCompraDireta"
                         :casasDecimais="casasDecimais"
                         :casasDecimaisQuantidade="casasDecimaisQuantidade"
                         :aceita-valor-zero="aceitaValorZero"
                         :criterioJulgamento="criterioJulgamentoDaCompra"
                         :simboloCriterioJulgamento="simboloCriterioJulgamentoDaCompra"
                         :validarLancesPor="validarIntervaloLancesPor"
                         :prefixSuffixValor="prefixOuSuffixValor"
                         :isCriterioJulgamentoMaiorDesconto="isCriterioJulgamentoMaiorDesconto"
                         @eventoAbrirModalReadequacao="eventoAbrirModalReadequacao"
                         @salvarItemReajuste="salvarItemLote"
                         @aceitarNegociacaoItem="enviarNegociacao"
                         @recusarNegociacaoItem="enviarNegociacao"/>

            <div v-if="!isCriterioJulgamentoMaiorDesconto && ehVencedorDeUmOuMaisItens()" class="total total-listagem">
                <p class="geral">
                    <strong>Valor Final da Proposta:&nbsp;</strong>
                    <span v-if="valorFinalProposta !== null">
                        {{ valorFinalProposta | cdCurrency(prefix, casasDecimais)}}{{suffix}}
                    </span>
                    <span v-else>&nbsp;-&nbsp;</span>
                </p>
            </div>

            <div v-if="!ehVencedorDeUmOuMaisItens()">
                <p class="mensagem-quando-vazio">Você não está vencendo a disputa de nenhum item.</p>
            </div>
            </div>
        </v-flex>

      <mensagem-confirmacao :exibirMensagem="mostrarDialogoConfirmacao"
                            v-bind:titulo="mensagemDialogo"
                            textoSecundario="Deseja realmente confirmar os valores reajustados da proposta?"
                            @confirmado="enviarReajuste"
                            @recusado="fecharDialogoConfirmacao"/>

        <div class="az-actions-form acao-botao">
            <botao-voltar @voltar="$emit('irParaPaginaAnterior')"/>
            <botao-avancar @avancar="$emit('irParaProximaPagina')"/>
        </div>

        <modal-enviar-readequacao :itemOuLote="reajusteItemOuLote"
                                   :visibilidadeDialogoReadequacao="visibilidadeDialogoReadequacao"
                                   :anexoReadequacao.sync="anexoReadequacao"
                                  @propagarEventoEnviarAnexoReadequacao="processarEventoEnviarAnexo"
                                  @fecharModalReadequacao="fecharModalReadequacao"
                                  @propagarEventoatualizarReadequacaoItemLote="propagarEventoatualizarReadequacaoItemLote">
        </modal-enviar-readequacao>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import PainelLote from './painel-lote/PainelLote'
import PainelItem from './painel-item/PainelItem'
import BotaoDownloadComLabel from '@/views/components/BotaoDownloadComLabel'
import BotaoAssinarComBorda from '@/views/components/BotaoAssinarcomBorda'
import {criteriosJulgamento, situacoesCompraDireta, situacoesReajusteProposta} from '@/core/constants'
import ModalEnviarReadequacao from '@/views/pages/fornecedor/resultado/documento-proposta/reajuste/ModalEnviarReadequacao'
import MensagemConfirmacao from '@/views/components/MensagemConfirmacao.vue'
import BotaoVoltar from '@/views/components/BotaoVoltar.vue'
import BotaoAvancar from '@/views/components/BotaoAvancar.vue'

export default {
    name: 'Reajuste',
    components: {
        BotaoAvancar,
        BotaoVoltar,
        MensagemConfirmacao,
        PainelItem,
        PainelLote,
        BotaoAssinarComBorda,
        BotaoDownloadComLabel,
        ModalEnviarReadequacao
    },
    $_veeValidate: {
        validator: 'new'
    },
    props: {
        reajusteItens: {
            type: Array,
            default: () => []
        },
        reajusteLotes: {
            type: Array,
            default: () => []
        },
        situacaoReajuste: {
            type: String,
        },
        valorFinalProposta: {
            type: Number,
            default: () => null
        },
        situacaoCompraDireta: {
            type: String,
            required: true
        },
        tipoCompraDireta: {
            type: String,
            required: true
        },
        disputaCompraDireta: {
            type: String,
            required: true
        },
        casasDecimais: {
            type: Number,
            required: true
        },
        aceitaValorZero:{
            type: Boolean,
            required: true
        },
        solicitadoAssinatura:{
            type: Boolean
        },
        reajusteAssinado:{
            type: Boolean
        },
        idVirtualizado:{
            type: String
        },
        urlVirtualizacaoReajuste:{
            type: String
        },
        criterioJulgamento:{
            type: String
        },
        simboloCriterioJulgamento:{
            type: String
        },
        prefixSuffixValor:{
            type: String
        },
        validarLancesPor:{
            type: String
        },
        anexoReadequacao: {
            type: Object,
            default: () => {}
        },
        casasDecimaisQuantidade:{
            type: Number,
            default: 2
        },
        relatorioReajuste: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        ...mapState(['fornecedor', 'resumoProposta']),
        ehReajusteFinalizado() {
            return (this.situacaoReajuste === situacoesReajusteProposta.FINALIZADO)
        },
        mensagemDialogo() {
            return this.reajusteLote ? 'Confirmar valores para o ' + this.reajusteLote.rotulo : 'Confirmar valores'
        },
        criterioJulgamentoDaCompra(){
            return this.criterioJulgamento
        },
        simboloCriterioJulgamentoDaCompra(){
            return this.simboloCriterioJulgamento
        },
        prefixOuSuffixValor(){
            return this.prefixSuffixValor
        },
        validarIntervaloLancesPor(){
            return this.validarLancesPor
        },
        prefix(){
            return this.prefixSuffixValor === 'R$' ? 'R$ ' : ''
        },
        suffix(){
            return this.prefixSuffixValor === '%' ? '%' : ''
        },
        isCriterioJulgamentoMaiorDesconto(){
            return this.criterioJulgamento === criteriosJulgamento.MAIOR_DESCONTO.valor
        },
        deveMostrarBotaoAssinarRelatorioReajuste(){
            return this.ehReajusteFinalizado && this.relatorioReajuste.solicitadoAssinatura &&  !this.relatorioReajuste.assinado &&  this.relatorioReajuste.urlAssinatura
        },
        ehCompraVirtualizada(){
            return this.resumoProposta.virtualizada
        }
    },
    mounted() {
        this.desabilitarLoadingGlobal()
    },
    data: () => ({
        mostrarOpcoesDownload: false,
        mostrarDialogoConfirmacao:false,
        reajusteLote: null,
        visibilidadeDialogoReadequacao: false,
        reajusteItemOuLote: {},
    }),
    methods: {
        ehVencedorDeUmOuMaisLotes(){
          return this.reajusteLotes.some(lote =>
              lote.situacao !== 'FINALIZADO' &&
              lote.situacao !== 'REABERTO_NEGOCIACAO'
          )
        },
        ehVencedorDeUmOuMaisItens() {
            return Boolean(this.reajusteItens.length) || Boolean(this.reajusteLotes.length)
        },
        exibirDialogoConfirmacao(reajusteLote) {
            this.reajusteLote = reajusteLote
            this.mostrarDialogoConfirmacao = true
        },
        fecharDialogoConfirmacao() {
            this.mostrarDialogoConfirmacao = false
        },
        enviarReajuste() {
            this.fecharDialogoConfirmacao()
            this.$emit('enviarReajusteLote', this.reajusteLote)
        },
        salvarItemLote(itemLote) {
            this.$emit('salvarItemLote', itemLote)
        },
        enviarNegociacao(comboDecisao) {
            this.$emit('enviarNegociacao', comboDecisao)
        },
        ehCompraDiretaEncerrada() {
            return this.situacaoCompraDireta === situacoesCompraDireta.ENCERRADA
        },
        downloadReajuste(tipoDownload, documentoVirtualizadoId) {
            this.$emit('gerarRelatorioReajustes', documentoVirtualizadoId, tipoDownload)
        },
        eventoAbrirModalReadequacao(reajuste){
            this.visibilidadeDialogoReadequacao = true
            this.reajusteItemOuLote = reajuste
        },
        processarEventoEnviarAnexo(arquivoAnexado){
            this.$emit('propagarEventoEnviarAnexoReadequacao', arquivoAnexado)
        },
        fecharModalReadequacao(){
            this.visibilidadeDialogoReadequacao = false
            this.reajusteItemOuLote = {}
            this.$emit('resetAnexoReadequacao')
        },
        propagarEventoatualizarReadequacaoItemLote(dados){
            this.$emit('atualizarReadequacaoItemLote', dados)
            this.visibilidadeDialogoReadequacao = false
            this.$emit('resetAnexoReadequacao')
        }
    },
}
</script>

<style scoped lang="stylus">

    .titulo
        font-size 1.1rem
        color #777
        margin-left 16px
        clear both

    .botao-documento
        padding-left 5px
        padding-bottom 5px

    .botao-principal
        background-color var(--v-primary-base) !important
        color #fff !important
        padding 10px 15px
        border 1px solid var(--v-primary-base) !important
        border-radius 2px

        i
            margin-right 0

    .geral
        font-size 15px

    .legenda-destacada
        font-size 15px
        color #664d03
        margin 8px 16px
        padding 5px 18px
        background-color #fff3cd !important
        border 1px solid #fff3cd !important
        border-radius 3px
        display flex
        flex-direction row

        p
            margin 0
            color #664d03 !important

        i
            color #664d03 !important

    @media (max-width 720px)
        .az-actions-form
            flex-direction column

        .botao-principal
            margin 20px 0

        .botao-default
            order 1
            margin 20px 0 0

    .mensagem-aviso-reajuste
        color white

    .botao-download-reajuste
        display flex
        justify-content flex-end

</style>
